export { default, type ReviewCardTemplateProps } from './ReviewCardTemplate';
